import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { AuthService } from "../../../services/auth/auth.service";
import { IframeModalService } from "../../../services/general/fullscreen.service";
import { environment } from './../../../../environments/environment';

@Component({
  selector: "app-admin-site-menu",
  templateUrl: "./admin-site-menu.component.html",
  styleUrls: ["./admin-site-menu.component.css"],
  animations: [
    trigger("visibility-menu", [
      state(
        "in",
        style({
          height: "*",
        })
      ),
      state(
        "out",
        style({
          height: "0",
          overflow: "hidden",
          display: "none",
        })
      ),
      transition("in => out", animate("200ms ease-in")),
      transition("out => in", animate("200ms ease-out")),
    ]),
  ],
})
export class AdminSiteMenuComponent implements OnInit {
  menuStructure: any[] = [];

  constructor(
    private authService: AuthService,
    private iframeModalService: IframeModalService
  ) {}

  ngOnInit() {
    const isAdmin = this.authService.isAdmin();

    if (isAdmin) {
      this.menuStructure = [
        {
          icono: "fa-cog",
          name: "General",
          status: "out",
          subItems: [
            {
              url: 'configuracion',
              name: 'Configuración',
            }
          ],
        },
        {
          icono: "fa-home",
          name: "Home Page",
          status: "out",
          subItems: [
            {
              url: "home-destacados",
              name: "Destacados",
            },
            {
              url: "especiales-portada",
              name: "Especial portada",
            },
            {
              url: "seleccion-start-fire",
              name: "Seleccion Start Fire",
            },
            {
              url: "popup",
              name: "Popup",
            },
            {
              url: "banda-informacion",
              name: "Banda información",
            },
            {
              url: "adjuntos",
              name: "Adjuntos Cotizaciones",
            },
          ],
        },
        {
          icono: "fa-columns",
          name: "Menús y Categorías",
          status: "out",
          subItems: [
            {
              url: "categorias",
              name: "Categorías",
            },
            {
              url: "categorias-especiales",
              name: "Categorías especiales",
            },
            {
              url: "especiales",
              name: "Especiales",
            },
            {
              url: 'descuentos',
              name: 'Descuentos',
            }
          ],
        },
        {
          icono: "fa-tag",
          name: "Productos",
          status: "out",
          subItems: [
            {
              url: "listado-productos",
              name: "Listado de productos",
            },
            {
              url: "crear-productos",
              name: "Crear productos",
            },
            {
              url: "ordenar-productos",
              name: "Ordenar productos",
            },
            {
              url: "historial-cambios-productos",
              name: "Historial cambios productos",
            },
            {
              url: 'descargar-productos',
              name: 'Descargar productos',
            }
          ],
        },
        {
          icono: "fa-bars",
          name: "Códigos",
          status: "out",
          subItems: [
            {
              url: "listado-codigos",
              name: "Listado de códigos",
            },
            {
              url: "cargar-codigos",
              name: "Cargar códigos",
            },
            {
              url: "descargar-listado-codigos",
              name: "Descargar listado de códigos",
            },
          ],
        },
        {
          icono: "fa-file-text-o",
          name: "Fichas",
          status: "out",
          subItems: [
            {
              url: "listado-fichas",
              name: "Listado de fichas",
            },
            {
              url: "categorias-documentos",
              name: "Categorias",
            },
          ],
        },
        {
          icono: "fa-trophy",
          name: "Certificaciones y Marcas",
          status: "out",
          subItems: [
            {
              url: "listado-certificaciones",
              name: "Certificaciones",
            },
            {
              url: "listado-marcas",
              name: "Marcas",
            },
          ],
        },
      ];
    } else {
      this.menuStructure = [
        {
          icono: "fa-bars",
          name: "Códigos",
          status: "out",
          subItems: [
            {
              url: "listado-codigos",
              name: "Listado de códigos",
            },
          ],
        }
      ]
    }
  }

  showSubMenu(index: number) {
    _.each(this.menuStructure, (item, i) => {
      if (index === i) {
        item.status = "in";
      } else {
        item.status = "out";
      }
    });
  }

  openIframe(url: string): void {
    const acccessToken = this.authService.getToken();
    this.iframeModalService.open(`${url}?token=${acccessToken}`);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/structure/admin-site-menu/admin-site-menu.component.ts